import { render, staticRenderFns } from "./TaxPaymentButton.vue?vue&type=template&id=68bbef1b&scoped=true&"
import script from "./TaxPaymentButton.vue?vue&type=script&lang=js&"
export * from "./TaxPaymentButton.vue?vue&type=script&lang=js&"
import style0 from "./TaxPaymentButton.vue?vue&type=style&index=0&id=68bbef1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bbef1b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/joeldev/Developer/clientes/aduanas-pty/front-transit/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {VIcon})
